import React from 'react';
import "./Header.css";


const Header = () => {
    return(
        <div className="header">
            <h1>gamArchive</h1>
        </div>
        
    )
}

export default Header;

